import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import ConnectionDetailReconnectButton from "./ConnectionDetailReconnectButton.layout";


const mapStateToProps = (state) => ({
  appObject: state.setAppId.value,
  language: state.languagesState.languages,
  advertiser: state.leadAllConnectionState.getAllLeadConnection.singleConnection?.source?.advertiser,
});

const decorate = compose(
  connect(mapStateToProps, null),
);

export default decorate(ConnectionDetailReconnectButton);